module.exports = __webpack_public_path__ + "img/9788972573876.f0b9180c.jpg";